module.exports = __webpack_public_path__ + "app/assets/images/man17-f943bb245f61bf7d1c81911dce8c86d1.jpg";